<template>
  <div>
    <!-- <div  style="display: flex; justify-content: end;">
            <q-icon name="close" style="font-size: x-large; cursor: pointer; " />
        </div> -->
    <q-blur v-if="showappcontainer" :intensity="2" class="blur-background">
      <q-dialog v-model="showappcontainer" v-if="sHow === true" class="app-container q-mx-md q-my-xl">
        <q-card>
          <q-card-section>
            <div>
              <q-dialog v-model="showLoadingDialog" class="loading-dialog" persistent>
                <q-card>
                  <q-card-section>
                    <div class="loading-spinner">
                      <q-spinner color="primary" size="50px" />
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div>
            <div>
              <q-dialog v-model="showCustomAlert" class="custom-alert" persistent>
                <q-card>
                  <q-card-section>
                    <div class="q-dialog__title">
                      <q-icon name="error" color="negative" size="2em" />
                      <span class="q-dialog__title-content">Seller selection mismatch</span>
                    </div>

                    <q-card-main>
                      <!-- Your custom content goes here -->
                      Seller ID doesn't match: Please make sure the seller you are choosing in this window matches with
                      the seller you are selecting from seller central!!
                    </q-card-main>
                  </q-card-section>

                  <!-- Okay button -->
                  <q-card-actions align="right">
                    <q-btn label="Okay" color="primary" @click="handleOkayClick" />
                  </q-card-actions>
                </q-card>
              </q-dialog>
            </div>
            <div>
              <q-dialog v-model="showregion">
                <q-card class="showregionform">
                  <q-card-section>
                    <div class="containers">
                      <div class="container-p1">
                        <p>Add a Seller Account</p>
                      </div>
                      <div class="container-p2">
                        <p>
                          Great, let's connect your existing <br />
                          account!
                        </p>
                      </div>
                      <div class="container-p3">
                        <p>
                          Connecting your uniQin account to Helium 10 will
                          unlock powerfull tools and insights for your business
                        </p>
                      </div>
                      <div class="container-p4">
                        <p>Choose the UniQin region in which you are selling</p>
                      </div>
                      <div class="container-img">
                        <div class="img1" @click="selectImage(0)" :class="{ highlighted: selectedImage === 0 }">
                          <img src="../assets/map1.jpg" alt="Northamerica" width="170px" height="150px" />

                          <p>
                            <span>North America</span><br />USA, Canada, Mexico,
                            Brazil
                          </p>
                        </div>
                        <div class="img2" @click="selectImage(1)" :class="{ highlighted: selectedImage === 1 }">
                          <img src="../assets/map2.jpg" alt="India" width="160px" height="150px" />

                          <p>
                            <span>Europe</span><br />DE,ES,FR,UK,IT,IN
                            <br />TR,NL,EG,SA,SE,PL
                          </p>
                        </div>
                        <div class="img3" @click="selectImage(2)" :class="{ highlighted: selectedImage === 2 }">
                          <img src="../assets/map3.jpg" alt="Asia" width="160px" height="150px" />

                          <p>
                            <span>Asia</span><br />Australia,Japan, Singapore
                          </p>
                        </div>
                      </div>
                      <div class="container-button">
                        <!-- <button @click="amazon_apis"><q-icon name="double_arrow" size="30px"></q-icon></button> -->
                        <button :disabled="connectedAdvertising === 'Connected'" v-if="api === 'Amazon-Advertising'"
                          :style="{
                            color: 'white',
                            padding: '10px',
                            border: 'none',
                            pointerEvents:
                              connectedAdvertising === 'Connected'
                                ? 'none'
                                : 'auto',
                          }" @click="amazon_apis" style="
                            background-color: #4b25ea;
                            font-size: large;
                            cursor: pointer;
                          ">
                          Authorize Ads
                        </button>
                        <!-- <button :disabled="connectedAdvertising === 'Connected'" v-if="api === 'Amazon-Seller'"
            :style="{ color: 'black', pointerEvents: connectedAdvertising === 'Connected' ? 'none' : 'auto' }"
            @click="amazon_apis" ><q-icon name="double_arrow" size="30px"></q-icon></button> -->
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div>
            <div>
              <q-dialog v-model="showsellerRegion">
                <q-card class="showregionform">
                  <q-card-section>
                    <div class="containers">
                      <div class="container-p1">
                        <p>Add a Seller Account</p>
                      </div>
                      <div class="container-p2">
                        <p>
                          Great, let's connect your existing <br />
                          account!
                        </p>
                      </div>
                      <div class="container-p3">
                        <p>
                          Connecting your uniQin account to Helium 10 will
                          unlock powerfull tools and insights for your business
                        </p>
                      </div>
                      <div class="container-p4">
                        <p>Choose the UniQin region in which you are selling</p>
                      </div>
                      <div style="
                          width: 160px;
                          height: 150px;
                          border: 2px solid white;
                          margin-bottom: 0;
                        ">
                        <img :src="selectedImages" alt="Selected Region Image" v-if="selectedRegion" width="150px"
                          height="140px" />
                      </div>
                      <div>
                        <div style="margin-left: 2px">
                          <q-btn-dropdown bg-color="#FAF9F9" :label="selectedRegion || 'Select Region'">
                            <q-list>
                              <q-item clickable v-close-popup @click="onclickregion('Select Region')">
                                <q-item-section>
                                  <q-item-label>Select Region</q-item-label>
                                </q-item-section>
                              </q-item>

                              <q-item clickable v-close-popup @click="onclickregion('us-east-1')">
                                <q-item-section>
                                  <q-item-label>us-east-1</q-item-label>
                                </q-item-section>
                              </q-item>

                              <q-item clickable v-close-popup @click="onclickregion('eu-west-1')">
                                <q-item-section>
                                  <q-item-label>eu-west-1</q-item-label>
                                </q-item-section>
                              </q-item>

                              <q-item clickable v-close-popup @click="onclickregion('eu-west-2')">
                                <q-item-section>
                                  <q-item-label>eu-west-2</q-item-label>
                                </q-item-section>
                              </q-item>
                            </q-list>
                          </q-btn-dropdown>
                        </div>
                      </div>

                      <div class="container-button">
                        <button :disabled="connectedAdvertising === 'Connected'" v-if="api === 'Amazon-Seller'" :style="{
                          color: 'black',
                          pointerEvents:
                            connectedAdvertising === 'Connected'
                              ? 'none'
                              : 'auto',
                        }" @click="amazon_apis">
                          <q-icon name="double_arrow" size="30px"></q-icon>
                        </button>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div>
            <!-- <div>
              <q-dialog v-model="showmerchants" persistent>
                <q-card class="showregionform">
                  <q-card-section>
                    <div style="margin-top: 0; border-bottom: 2px solid #ccc">
                      <header class="header-class">
                        <div style="display: flex; justify-content: center">
                          <img src="../assets/cart.png" width="30px" />
                          <q-icon name="sync_alt" size="xs" style="margin-top: 5px" />
                          <img src="../assets/amazon.png" width="28px" style="
                              border: 2px solid black;
                              border-radius: 15px;
                              padding: 5px;
                            " />
                        </div>
                        <div>Connect Amazon data</div>
                      </header>
                    </div>
                    <div style="display: flex; justify-content: center">
                      <img src="../assets/connected.jpg" width="150px" />
                    </div>
                    <div class="merchant-container">
                      <div class="merchant-header">
                        <p>Select Merchants to connect</p>
                      </div>
                      <div class="p">
                        <p>
                          You will log into the Amazon Ads Console and select
                          <br />
                          the merchants you want to connect. We will then use
                          <br />
                          Your selections to connect ads and products data.
                        </p>
                      </div>
                    </div>
                    <footer class="merchant-footer">
                      <div class="merchant-buttons">
                        <div class="button1">
                          <button style="width: 100px">
                            <q-icon name="keyboard_backspace" size="sm"></q-icon>Back
                          </button>
                        </div>
                        <div class="button2">
                          <button @click="amazon_apis">Authorize Ads</button>
                        </div>
                      </div>
                    </footer>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div> -->
            <div>
              <q-dialog v-model="showprofiles" persistent :maximized="$q.screen.lt.sm">
                <q-card class="showprofileData">
                  <q-card-section>
                    <div>
                      <div style="margin-top: 0; border-bottom: 2px solid #ccc">
                        <header class="header-class">
                          <!-- <div style="display: flex; justify-content: center">
                            
                            <img src="../assets/Updated_Logo.png" width="100px" style="
                    border: 2px solid black;
                    border-radius: 15px;
                    padding: 5px;
                  " />
                          </div> -->
                          <div>Connect Amazon data</div>
                        </header>
                      </div>
                      <div v-if="tabulardata === undefined" style="text-align: center; padding: 20px;">
                        <!-- Loading indicator (e.g., spinner) -->
                        <q-spinner-gears color="primary" size="50px" />
                        <p>Loading...</p>
                      </div>
                      <div v-else>
                        <p style="
                              font-size: large;
                              font-weight: bold;
                              margin-top: 5%;
                            ">
                          {{ tabulardata.length }} merchants available
                        </p>
                        <!-- <div class="showmerchantform">
                          <table>
                            <thead>
                              <tr>
                                <th style="border: none">
                                  <input id="select-all-checkbox" class="custom-checkbox" type="checkbox"
                                    v-model="selectAll" @change="selectAllCheckboxes" />
                                </th>
                                <th>SELLER NAME</th>
                                <th>COUNTRY</th>
                                <th>TYPE</th>
                                <th>MERCHANT ID</th>
                              </tr>
                            </thead>
                            <tbody>
                              <template v-for="(item, index) in tabulardata">
                                <tr :key="index" style="text-align: left;">
                                  <td>
                                    <input :id="'checkbox-' + index" type="checkbox" :checked="item.selected"
                                      @change="handleCheckboxChange(index)" /><label :for="'checkbox-' + index"></label>
                                  </td>

                                  <td>{{ item.profile_name }}</td>
                                  <td>

                                    {{ item.country_code }}

                                  </td>
                                  <td>{{ item.seller_type }}</td>
                                  <td>{{ item.seller_id }}</td>
                                </tr>
                              </template>
                            </tbody>
                          </table>
                        </div> -->
                        <div>
                          <table>
                            <tr>
                              <th><input id="select-all-checkbox" class="custom-checkbox" type="checkbox"
                                  v-model="selectAll" @change="selectAllCheckboxes" /></th>
                              <th>SELLER NAME</th>
                              <th>COUNTRY</th>
                              <th>TYPE</th>
                              <th>MERCHANT ID</th>
                            </tr>
                            <tr v-for="(item, index) in tabulardata" :key="index" style="text-align: left;">
                              <td>
                                <input :id="'checkbox-' + index" type="checkbox" :checked="item.selected"
                                  @change="handleCheckboxChange(index)" /><label :for="'checkbox-' + index"></label>
                              </td>

                              <td>{{ item.profile_name }}</td>
                              <td>

                                {{ item.country_code }}

                              </td>
                              <td>{{ item.seller_type }}</td>
                              <td>{{ item.seller_id }}</td>
                            </tr>
                          </table>

                        </div>
                        <div class="profile-button">
                          <!-- <div>
                            <button class="profile-cancel">Cancel</button>
                          </div> -->
                          <div>
                            <button class="profile-continue" @click="savedata">
                              Continue
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div>
            <!-- <div>
              <q-dialog v-model="showsuccessmsg">
                <q-card class="showsucessmsg">
                  <q-card-section>
                    <div>
                      <div style="margin-top: 0; border-bottom: 2px solid #ccc">
                        <header class="header-class">
                          <div style="display: flex; justify-content: center">
                            <img src="../assets/cart.png" width="30px" />
                            <q-icon name="sync_alt" size="xs" style="margin-top: 5px" />
                            <img src="../assets/amazon.png" width="28px" style="
                                border: 2px solid black;
                                border-radius: 15px;
                                padding: 5px;
                              " />
                          </div>
                          <div>Connect Amazon data</div>
                        </header>
                      </div>
                      <div style="display: flex; justify-content: center">
                        <img src="../assets/Success.png" alt="success" />
                      </div>
                      <div style="display: flex; justify-content: center">
                        <p style="font-size: x-large">
                          <span stlye="font-size: 40px; width: 60px;">&#x1F389;</span>Success
                        </p>
                      </div>
                      <div style="display: flex; justify-content: center">
                        <p style="font-size: large">
                          Here's what happens next:
                        </p>
                      </div>
                      <div class="success-box1">
                        <div class="success-container">
                          <div>
                            <p>
                              <q-icon name="done" size="sm" style="width: 50px; color: #35c477" />
                            </p>
                          </div>
                          <div id="container-1">
                            <p id="p">We'll start connecting your ads data</p>
                            <p style="font-size: 110%">
                              We'll ping you once your advertising data is
                              <br />
                              ready in uniQin or if we bump into any issues
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="success-box1" style="margin-top: 10px">
                        <div class="success-container">
                          <div>
                            <p>
                              <q-icon name="arrow_forward" size="sm" style="width: 50px; color: #5a37ec"></q-icon>
                            </p>
                          </div>
                          <div id="container-1">
                            <p id="p">Connect Your products data</p>
                            <p style="font-size: 110%">
                              You don't sell ads, so we need your products
                              <br />data to better optimize Your ad efforts and
                              <br />fine them to perfection
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="success-btn-container">
                        <div>
                          <button @click="authorizeproducts" style="cursor: pointer">
                            Authorize Products
                          </button>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div> -->
            <div>
              <q-dialog v-model="showproductsdata" persistent :maximized="$q.screen.lt.sm">
                <q-card class="showproductsdata">
                  <q-card-section>
                    <div style="display: flex; justify-content: left;">
                      <p style="font-size: large; cursor: pointer;color: #378CEF;" @click="back">Back</p>

                    </div>
                    <div>
                      <div style="margin-top: 0; border-bottom: 2px solid #ccc">
                        <header class="header-class">
                          <!-- <div style="display: flex; justify-content: center">
                            <img src="../assets/cart.png" width="30px" />
                            <q-icon name="sync_alt" size="xs" style="margin-top: 5px" />
                            <img src="../assets/amazon.png" width="28px" style="
                                border: 2px solid black;
                                border-radius: 15px;
                                padding: 5px;
                              " />
                          </div> -->
                          <div>Connect Amazon data</div>
                        </header>
                      </div>
                      <div style="margin-top: 20px">
                        <p><strong>Add Seller/Vendor central data</strong></p>
                        <p>
                          Authorize uniQin.ai data access to products data for
                          your selected merchants in the following regions:
                        </p>
                      </div>
                      <div>

                        <div v-if="showRegionGpedProfiles" class="scrollable-container">

                          <div v-for="(value, key) in this.sellers" :key="key">
                            <div style="
                            width: auto;
                            height: 100px;
                            border: 2px solid #ccc;
                            padding-top: 20px;
                            margin-top: 20px;
                            cursor: pointer;
                          ">
                              <div style="
                              display: flex;
                              justify-content: space-between;
                            ">
                                <div style="display: flex">
                                  <q-icon name="arrow_forward" size="sm" style="margin-top: 3px"></q-icon>
                                  <p>
                                    <strong>{{ value.seller_name }} </strong>-<span v-if="value.seller_type"
                                      class="seller-type-container">
                                      {{ value.seller_type === 'seller' ? '3P Sellers' : '1P Vendors' }}
                                    </span>
                                    <button style="
                                    border: none;
                                    color: blue;
                                    background-color: #f3f0fd;
                                    border-radius: 30px;
                                    padding: 5px;
                                    margin-left: 5px;
                                  ">
                                    </button><br />

                                    {{ get_country_names(value.sellers_country) }}
                                  </p>
                                  <!-- <button>1P Vendors</button> -->
                                </div>
                                <div style="margin-right: 30px">
                                  <button style="
                                  padding: 10px;
                                  background-color: #378cef;
                                  color: white;
                                  border: none;
                                  border-radius: 10px;
                                  cursor: pointer;
                                "
                                    @click="authorizeRegion(value.endpoint, value.region, value.seller_id, value.seller_name)">
                                    Authorize
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div>
            <div>
              <q-dialog v-model="AdConnection" persistent :maximized="$q.screen.lt.sm">
                <q-card class="showproductsdata">
                  <q-card-section>
                    <div>
                      <div style="margin-top: 0; border-bottom: 2px solid #ccc">
                        <header class="header-class">
                          <!-- <div style="display: flex; justify-content: center">
                            <img src="../assets/Updated_Logo.png" width="100px" style="
                    
                    border-radius: 15px;
                    padding: 5px;
                  " />
                          </div> -->
                          <div>Connect Amazon data</div>
                        </header>
                      </div>

                      <div class="para q-mt-md">
                        <p><strong>uniQin.ai</strong> needs to connect to two Amazon data sources:</p>
                      </div>
                      <div>
                        <div class="amazon-adbox" style="margin-top: 7%">
                          <div class="box1" style="width: 458px">
                            <ul style="font-size: larger; font-weight: bold;list-style-type:disc;">
                              <li>Amazon Advertising</li>
                            </ul>
                            <!-- <button style="
                      padding: 5px;
                      height: 30px;
                      margin-left: 1%;
                      border-radius: 30px;
                      cursor: pointer;
                    ">
                              Required
                            </button> -->
                          </div>
                          <div>
                            <p>Step 1 - Connect Amazon Ad</p>
                          </div>
                        </div>
                        <div class="amazon-adbox1">
                          <div class="box2">
                            <ul style="list-style-type: disc; font-size: larger; font-weight: bold;">
                              <li>Amazon Selling Partner</li>
                              <!-- Add more list items if needed -->
                            </ul>
                            <!-- <button style="
                      padding: 5px;
                      height: 30px;
                      margin-left: 1%;
                      border-radius: 30px;
                      cursor: pointer;
                    ">
                              Required
                            </button> -->
                          </div>
                          <div>
                            <p>
                              Step 2 - Connect seller central
                            </p>
                          </div>
                        </div>
                        <!-- </q-radio> -->
                        <footer>
                          <div style="display: flex; justify-content: end; margin-top: 4%">
                            <div class="connect-button q-py-sm" style="margin-top: 5%">
                              <button class="button-advertising" :disabled="connectedAdvertising === 'Connected'"
                                v-if="selectedBox === 'Amazon-Advertising'" :style="{

                                  cursor: 'pointer',
                                  pointerEvents:
                                    connectedAdvertising === 'Connected'
                                      ? 'none'
                                      : 'auto',
                                }" @click="redirectToAmazon"
                                style="background-color: #378cef; color: white; border: none">
                                Connect Amazon Advertising
                              </button>
                              <button :disabled="connectedSeller === 'Connected'" v-if="selectedBox == 'Amazon-Seller'"
                                :style="{
                                  color: 'white',
                                  cursor: 'pointer',
                                  pointerEvents:
                                    connectedSeller === 'Connected' ? 'none' : 'auto',
                                }" @click="redirectToseller"
                                style="background-color: #378cef; color: white; border: none">
                                Continue
                              </button>
                            </div>
                          </div>
                        </footer>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </q-dialog>
            </div>

          </q-card-section>
        </q-card>
      </q-dialog>
    </q-blur>
    <!-- <div>
      <q-blur v-if="showorganizationform" :intensity="5" class="blur-background">
        <q-dialog v-model="showorganizationform" persistant>
          <q-card class="organizationform">
            <q-card-section>
              <q-form @submit.prevent="proceed">
                <div class="input-organization">
                  <div>
                    <div styel="display: flex; justify-content:center;" class="q-mb-md">
                      <h6>Let's go! You're almost there...</h6>
                    </div>
                    <div class="q-mb-md">
                      <q-input outlined v-model="top_level_org_name" placeholder="Enter Your Organization Name"
                        :dense="dense" bg-color="white" />
                    </div>
                    <div class="q-mb-md">
                      <q-select v-model="Typeofbusiness" label="Select Your Type Of Business" :options="businessTypes"
                        outlined />
                    </div>
                    <div class="q-mb-md">
                      <q-input outlined v-model="targeted_monthly_sale" label="Monthly AD Sales" type="text" />
                    </div>
                    <div class="q-mb-md">
                      <q-input outlined v-model="targeted_ad_cost" label="Monthly AD Cost" type="text" />
                    </div>

                    <div class="q-mb-md">
                      <q-select v-model="operating_country" label="Operating Country" :options="Countries" outlined />
                    </div>
                    <div class="q-mb-lg">
                      <q-select v-model="preferred_timezone" label="Preferred Time Zone" :options="timezone" outlined />
                    </div>

                    <div class="q-mb-md text-center">
                      <q-btn label="Proceed" type="submit" class="proceed-button" />
                    </div>
                  </div>
                  
                </div>
              </q-form>
            </q-card-section>
          </q-card>
        </q-dialog>
      </q-blur>
    </div> -->
    <div>
      <q-blur v-if="showorganizationform" :intensity="5" class="blur-background">
        <q-dialog v-model="showorganizationform" persistent :maximized="$q.screen.lt.sm">
          <q-card class="businessform">
            <q-card-section>
              <div class="organizationform-container">
                <div>
                  <q-form @submit.prevent="next">

                    <div>
                      <div class="orgform-header q-mb-md">
                        <p>Let's go! You're almost there...</p>
                        <!-- <p>Step 1/2</p> -->
                      </div>
                      <div class="orgnizationName q-mb-md">
                        <div style="display: flex;justify-content: left;">
                          <p class="heading-text">Business Name<span style="color:red">*</span></p>
                          <!-- <p v-if="!top_level_org_name" style="color: red;">Required</p> -->
                          <p style="margin-left: 40%; "><strong>{{ filteredBusinessName }}</strong></p>
                        </div>


                        <input v-model="top_level_org_name" placeholder="Enter Your Business Name" :dense="dense"
                          bg-color="white" :class="{ 'shake': businessNameError }"
                          style="height:60px;border-radius:5px;padding:10px;background-color: white;border: 2px solid #ccc;border-bottom: 2px solid #ccc !important;" />
                        <div style="color: red;" v-if="top_level_org_nameError">{{ top_level_org_nameError }}</div>



                      </div>
                      <div class="q-mb-md">
                        <div class="business-type-name">
                          <p class="heading-text">Select Your Type Of Business<span style="color:red">*</span></p>
                          <!-- <q-field-message v-if="!Typeofbusiness" style="color: red;">Required</q-field-message> -->
                        </div>
                        <div class="business-types">
                          <div v-for="businessType in businessTypes" :key="businessType.value" class="sub-division">
                            <q-radio class="qradio" v-model="Typeofbusiness" :val="businessType.value"
                              :label="businessType.label" color="primary" />
                          </div>

                        </div>
                        <p style="color:rgb(29, 186, 29)">{{ getSelectedMessage() }}</p>
                        <div style="color: red;" v-if="businessNameError">{{ businessNameError }}</div>
                      </div>
                      <div class="countries q-mb-lg">

                        <div style="display: flex;justify-content:left;">
                          <label style="margin-top: 10px;margin-bottom: 0px;" class="heading-text">Select the
                            Country<span style="color:red">*</span></label>

                        </div>
                        <div class="countryList">
                          <q-select v-model="operating_country" label="Select" :options="Countries"
                            @input="updateTimezones" outlined />
                          <div style="color: red;" v-if="operating_country_error">{{ operating_country_error }}</div>
                        </div>
                      </div>

                      <div class="timezone-orgform q-mb-lg">
                        <p class="heading-text">Preferred Time Zone</p>
                        <q-select class="qselect" v-model="preferred_timezone" label="Preferred Time Zone"
                          :options="this.timezones" outlined />
                      </div>

                      <!--<div style="display: flex;justify-content: space-between;">
                        <div class="q-mb-md">
                          <label style="margin-top: 10px;" class="heading-text">Monthly-Ad Sales</label>
                          <q-input square v-model="targeted_monthly_sale" placeholder="Monthly AD-Sales" type="number"
                            :bg-color="'white'" style="border-radius:10px" @input="validateNumberInput" />
                        </div>
                        <div class="q-mb-md">
                          <label class="heading-text">Monthly AD Cost</label>
                          <q-input v-model="targeted_ad_cost" placeholder="Monthly AD-Cost" type="number"
                            style="border-radius:10px" @input="validateNumberInput" />
                        </div>
                      </div>-->


                      <div class="btn-orgform q-mb-md ">
                        <q-btn style="background-color: #378cef;color: white;" label="Next" type="submit"
                          class="proceed-button" :disabled="disablenext" />
                      </div>
                    </div>
                  </q-form>
                  <div style="color:red;text-align: center;" v-if="orgerrorMessage">
                    {{ orgerrorMessage }}
                  </div>

                </div>
                <!-- <div style="background-color: #2F2849; color: white; padding: 20px 20px 20px 20px; width: 60%;margin-top: 40px;margin-left: 20px;"> 
                  <div>
                  <p style="font-size: large;">Join Uniqin for free and gain access to</p>
                  </div>
                  <div>

                    <ul style="list-style-type:square; padding:0; color: #35c477;margin-left: 5px;">
                      <li>AI algorithmic bidding</li>
                      <li>Best-in-class campaign creation</li>
                      <li>Keyword recommendations</li>
                      <li>Seller community</li>
                      <li>Expect support & more!</li>
                    </ul>
                  </div>
                  
                </div> -->
              </div>

            </q-card-section>
          </q-card>
        </q-dialog>
      </q-blur>
    </div>
    <div>
      <q-blur v-if="showphnoverification" :intensity="5" class="blur-background">
        <q-dialog v-model="showphnoverification" persistent :maximized="$q.screen.lt.sm">
          <q-card class="verificationForm">
            <q-card-section>
              <div style="display:flex;">
                <img src="../assets/phone-unlocked.jpg" width="100px" height="100px">
                <p style="font-size: large;font-weight:bold;">Welcome to uniQin.ai! Please verify
                  your phone number for Amazon sales update.</p>
              </div>
              <div class="countryCodes">
                <vue-country-code @onSelect="onSelect" :preferredCountries="['vn', 'us', 'gb']" :defaultCountry="'in'"
                  style="height: 50px;"></vue-country-code>
                <input ref="phoneNumber" maxlength="10" type="tel" placeholder="Enter Phone NO"
                  @input="onPhoneNumberInput" v-model="phoneNumber"
                  style="margin-left:0px;padding-left: 5px; margin-top:0px;width:100%;border: 2px solid #CACACA; border-bottom: 2px solid #CACACA !important;background-color: white;">
              </div>
              <div class="agree">

                <div>
                  <input type="checkbox" v-model="selectCheckbox">
                </div>
                <div style="margin-left:5px">
                  <p>I agree to receive updates & reports on WhatsApp </p>
                </div>

                <!-- <div class="wtspimg" ><img src="../assets/whatsapp.jpg" width="20px" height="20px"></div> -->
              </div>

              <q-btn class="verify" style="border-radius: 0px;" @click="sendOTP"
                :disabled="isPhoneNumberValid || isSendButtonDisabled || this.selectCheckbox === false">
                Send OTP
              </q-btn>
              <div v-if="timerCountdown > 0" style="margin-top:10px;">
                <p style="text-align: center;">Didn't recieve OTP ? Resend OTP in {{ timerCountdown }} seconds</p>
              </div>
              <div style="color:green;text-align: center;font-size: bold;margin-top: 10px;" v-if="otpsuccessmsg">{{
                otpsuccessmsg }}</div>
              <div style="color:red;text-align: center;font-size: bold;margin-top: 10px;" v-if="otpErrormessage">{{
                otpErrormessage }}</div>

              <div v-else style="display: flex;">

              </div>

              <!-- <span v-if="isSendButtonDisabled" class="timer">{{ timerCountdown }}s</span> -->
              <div style="margin-top: 50px;">
                <p>Please enter the One-Time Password (OTP) in the specified field for verification!</p>
              </div>
              <div style="display: flex;" class="otp-card-inputs">
                <input v-model="otp" class="otp-box" @input="onOtpInput" maxlength="6" placeholder="Enter OTP"
                  style="margin-left:0px; width:100%;background-color:white; border-bottom: 1px solid #CACACA !important;">

              </div>
              <div style="color:red;text-align: center;font-size: bold;margin-top: 10px;" v-if="verifyErrormsg">{{
                verifyErrormsg }}</div>
              <q-btn class="verify" style="border-radius: 0px;" @click="verifyOTP"
                :disabled="!isOtpEntered">Verify</q-btn>


            </q-card-section>
          </q-card>
        </q-dialog>
      </q-blur>
    </div>

  </div>
</template>
<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap");
@import url("https://fonts.googleapis.com/css?family=Muli");

body {
  font-family: Montserrat;
}



.app-container {
  /* margin-top: 5%;
    margin-left: 2%; */
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  min-height: 565px;
  min-width: 510px;
  padding: 10px;
  width: 510px;
  z-index: 2;

  overflow-x: hidden !important;
}

.custom-alert {
  max-width: 400px;
  /* Set the desired width */
}

#whole-1 {
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
}

.screen {
  width: 531px;
  height: 392px;
  border-radius: 35px;
  /* UI Properties */
  background: #f7f8fa 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000021;
  opacity: 1;
  opacity: 1;
}

.screen h5 {
  justify-content: center;
  display: flex;
}

.title-head {
  text-align: center;
  font: normal normal bold 20px/20px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.bluehead {
  border-radius: 10px 10px 0px 0px;
  /* UI Properties */
  background: #102689 0% 0% no-repeat padding-box;
  opacity: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  text-align: left;
  font: normal normal 600 20px/24px Montserrat;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}

.region {
  text-align: center;
  border-radius: 20px;
  /* UI Properties */
}

.region-dropdown {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 14px;
  opacity: 1;
}

.note {
  text-align: center;
  font: normal normal 600 14px/20px Montserrat;
  letter-spacing: 0px;
  color: #ff0000;
  opacity: 1;
}



.reg {
  text-align: left;
  font: normal normal 600 13px/16px Montserrat;
  letter-spacing: 0px;
  color: #0c1125;
  opacity: 1;
  margin-top: 30px;
}

.region {
  width: auto;
  height: auto;
  /* UI Properties */
  background: #f1f2f6 0% 0% no-repeat padding-box;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  opacity: 1;
  text-align: left;
  font: normal normal bold 13px/16px Montserrat;
  letter-spacing: 0px;
  color: #0c1125;
  opacity: 0.65;
}

.q-btn-dropdown__arrow {
  color: #378cef !important;
  margin-left: 30px;
}

.para {
  text-align: left;
  font: normal normal 600 15px/26px Montserrat;
  margin-left: 0px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.8;
}

.radio-button {
  text-align: center;
  font: normal normal 600 20px/32px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.8;
  align-items: center;
  justify-content: center;
  display: block;
}

.header-class {
  text-align: center;
  /* margin: 3%; */
  font-weight: bold;
  font-size: large;
  padding: 10px;
}

.amazon-adbox {
  width: 100%;
  height: 130px;
  /* background-color: #faf9f9; */
  /* border: 2px solid #e9e9e9; */
}

.amazon-adbox1 {
  width: 100%;
  height: 140px;
  /* background-color: #faf9f9; */
  /* border: 2px solid #e9e9e9; */
  margin-top: 3%;
}

.amazon-adbox>.box1 {
  margin-top: 2%;
  display: flex;
  justify-content: start;
}

.amazon-adbox1>.box2 {
  margin-top: 2%;
  display: flex;
  justify-content: start;
}

.organizationform {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  min-height: 565px;
  min-width: 510px;
  padding: 10px;
  width: 800px;
  z-index: 2;

  overflow-x: hidden !important;
}


/* .blur-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  backdrop-filter: blur(3px);

} */

.showregionform {
  /* margin-top: 5%;
    margin-left: 2%; */
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  min-height: 565px;
  min-width: 510px;
  padding: 10px;
  width: 510px;
  z-index: 2;

  overflow-x: hidden !important;
}

.showmerchantform {
  background-color: #fff;
  border-radius: 10px;
  min-width: 510px;
  padding: 10px;
  width: auto;
  height: 400px;
  z-index: 2;
  margin-left: 0%;
  overflow-y: auto;
  overflow-x: hidden !important;
}

.scrollable-container {
  height: 400px;
  /* Set your desired maximum height */
  overflow-y: auto;
  /* Enable vertical scrollbar when content overflows */
}

.seller-type-container {
  /* background-color: #badaf4; */
  border-radius: 7px;
  padding: 1px;
  /* Adjust padding as needed */
  display: inline-block;
  /* Ensure the span only takes up the necessary width */
}

.showsucessmsg {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  min-height: 565px;
  min-width: 510px;
  padding: 10px;
  width: 510px;
  z-index: 2;

  overflow-x: hidden !important;
}

.connect-button {
  display: flex;
  justify-content: end;
  color: white;

  background: #378cef 0% 0% no-repeat padding-box;
  border-radius: 10px;


  padding: 10px;
}

.showproductsdata {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  width: 510px;
  z-index: 2;

  overflow-x: hidden !important;
}

@media only screen and (max-width:600px) {
  .showproductsdata {
    width: 80%;
    max-width: none;
  }

  .connect-button {
    display: flex;
    justify-content: center;
  }

}

.container-p1>p {
  color: #a1a6aa;
  margin: 0;
  padding: 0;
}

.container-p2>p {
  font-size: x-large;
  font-weight: bold;
}

.container-p3>P {
  color: #9cb8cc;
}

.container-p4>p {
  font-weight: 700;
}

.container-img {
  display: flex;
  justify-content: space-around;
}

.container-img>.img1 {
  width: 250px;
  height: 250px;
  border: 2px solid #eef1f4;
  margin-left: 10px;
  cursor: pointer;
}

.container-img>.img2 {
  width: 250px;
  height: 250px;
  border: 2px solid #eef1f4;
  margin-left: 10px;
  cursor: pointer;
}

.container-img>.img3 {
  width: 250px;
  height: 250px;
  border: 2px solid #eef1f4;
  margin-left: 10px;
  cursor: pointer;
}

.container-img>.img1>p>span {
  text-align: center;
  font-size: large;
  font-weight: 900;
}

.container-img>.img2>p>span {
  text-align: center;
  font-size: large;
  font-weight: 900;
}

.container-img>.img3>p>span {
  text-align: center;
  font-size: large;
  font-weight: 900;
}

.highlighted {
  /* border: 5px solid blue;  */
  cursor: pointer;
  color: black;
}

.container-button {
  display: flex;
  justify-content: end;
  margin-top: 30px;
}

.sellername {
  background-color: unset;
  border: none;
}

.selected {
  border-color: grey;
  /* Add a style for the selected box */
}

.selected1 {
  border-color: blue;
}

.merchant-container {
  text-align: center;
}

.merchant-container>.merchant-header>p {
  font-size: x-large;
}

.merchant-container>.p>p {
  font-size: 120%;
  font-family: "Poppins", sans-serif !important;
}

.merchant-footer {
  margin-top: 25%;
  border-top: 2px solid #ccc;
}

.merchant-footer>.merchant-buttons {
  margin-top: 5%;
}

.merchant-footer>.merchant-buttons {
  display: flex;
  justify-content: space-between;
}

.merchant-footer>.merchant-buttons>.button1>button {
  padding: 10px;
  font-size: larger;
  background-color: unset;
  border: 2px solid #d6dce2;
  cursor: pointer;
}

.merchant-footer>.merchant-buttons>.button2>button {
  padding: 10px;
  background-color: #4b25ea;
  border-radius: 5px;
  border: none;
  color: white;
  cursor: pointer;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;


}

@media only screen and (max-width: 600px) {

  th,
  td {

    width: 100%;
    box-sizing: border-box;
    margin-bottom: 5px;
  }

  th,
  td:nth-child(2) {
    text-align: center;
  }
}

th input[type="checkbox"] {
  margin-right: 5px;
}

.profile-button {
  display: flex;
  justify-content: end;
  margin-top: 5%;
}

.profile-button div .profile-cancel {
  border: none;
  height: 40px;
  background-color: unset;
  margin-right: 20px;
}

.profile-button div .profile-continue {
  background-color: #378cef;
  padding: 10px;
  height: 40px;
  border: none;
  color: white;
}

.success-box1 {
  height: auto;
  border: 1px solid #a1a6aa;
}

.success-box1>.success-container {
  display: flex;
}

.success-box1>.success-container>#container-1>#p {
  font-size: large;
  font-weight: bold;
}

.success-btn-container {
  border-top: 2px solid #ccc;
  margin-top: 20px;
}

.success-btn-container>div {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.success-btn-container>div>button {
  background-color: #4b25ea;
  padding: 10px;
  color: white;
  font-size: medium;
  border: none;
  border-radius: 10px;
}

.organizationform-container {
  display: flex;
  justify-content: space-between;
  /* width: 1000px; */

}

.organizationform-subcontainer {
  width: 50%;
  height: 80vh;
  padding: 10px;
  margin-right: 20px;
}

.btn-orgform {
  display: flex;
  justify-content: end;
}

.proceed-button {
  background-color: #378cef;
  color: white;

}

.business-types {
  display: flex;
  flex-direction: row;
}

/* Add margin between radio buttons if needed */
.business-types div {
  margin-right: 10px;
}

.orgform-header {
  display: flex;
  justify-content: space-between;
}

.orgform-header h6 .pages {
  font-size: small;
  margin-left: 60%;

}

.orgform-header p {
  font-size: x-large;
  font-weight: bold;
}

.business-type-name {
  display: flex;
  justify-content: left;
}

.businessform {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);

  min-height: 60%;
  max-width: 90%;
  padding: 10px;

  width: 510px;
  z-index: 2;

  overflow-x: hidden !important;
}

@media only screen and (max-width:600px) {
  .businessform {
    width: 80%;
    max-width: none;
  }

  .btn-orgform {
    display: flex;
    justify-content: center;

  }

  .timezone-orgform .qselect {
    width: 100%;

  }

  .timezone-orgform .heading-text {
    font-size: small;
  }

  .countries .countryList {
    width: 100%;
  }

  .countries div .heading-text {
    font-size: small;
  }

  .orgnizationName input {
    width: 100%;
  }

  .orgnizationName .heading-text {
    font-size: small;
  }

  .business-type-name .heading-text {
    font-size: small;
  }

  .business-types {
    display: block;
  }

  .orgform-header h6 {
    font-size: large;
  }

  .orgform-header h6 .pages {
    margin-left: 30%;
  }


}

li {
  margin-bottom: 10px;
  font-size: large;
}



.shake {
  animation: shake 0.5s;
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }

  20% {
    transform: translateX(-8px);
  }

  40% {
    transform: translateX(8px);
  }

  60% {
    transform: translateX(-4px);
  }

  80% {
    transform: translateX(4px);
  }

  100% {
    transform: translateX(0);
  }
}

.phono-verfi-field {
  display: flex;
  justify-content: center;
  border: 1px solid black;
}

.phono-verfi-field>#container1>select {
  border: none;
  border-right: 2px solid black;
  width: 50px;

}

.phono-verfi-field>#container1>input {
  /* padding: 0; */

  background-color: white;
}

.phono-verfi-field>.phono-button-verify {
  margin-left: 50px;
}

.otp-container {
  display: flex;
  justify-content: center;
  background: unset;

}

.otp-box {
  width: 70%;
  /* margin-top: 15px; */
  padding: 10px;
  font-size: 14px;
  border: 1px solid #CACACA;

  border-radius: 4px;
  outline: none;
  transition: border-color 0.3s;
  background-color: white;
}

/* .otp-box:focus {
  border-color: #007bff;
} */

.heading-text {
  font-weight: bold;
  font-size: medium;
}

.agree {
  display: flex;
  margin-top: 20px;
}

.verificationForm {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, .4);

  min-height: 60%;
  max-width: 90%;
  padding: 10px;

  width: 510px;
  z-index: 2;

  overflow-x: hidden !important;

}

.countryCodes {
  display: flex;
}

.countrycode-input {
  display: flex;
  justify-content: left;
}

@media only screen and (max-width:600px) {
  .verificationForm {
    width: 80%;
    max-width: none;
  }

  .countrycode-input {
    display: flex;
  }

  .agree>.wtspimg {
    display: flex;
    justify-content: left;
  }
}

.showprofileData {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  min-height: 60%;
  max-width: 90%;
  padding: 10px;
  width: 560px;
  z-index: 2;

  overflow-x: scroll !important;

}

@media screen and (max-width:600px) {
  .showprofileData {
    width: 80%;
    max-width: none;
  }

  .showmerchantform table {
    width: fit-content;
  }

}
</style>
<script>
import axios from 'axios';
import Vue from "vue";
import VueCountryCode from "vue-country-code-select";
Vue.use(VueCountryCode);
export default {
  data() {
    return {
      timerCountdown: 0,
      isAuthenticated: true,
      preview: false,
      api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
      app_url: this.$store.state.APP_URL[process.env.VUE_APP_ENV],
      dynamic_url: "",
      amazon_url: "",
      connectedSeller: "Connect Amazon Selling partner",
      connectedAdvertising: "Connect Amazon Advertising",
      org_id: 0,
      hide_panel: {},
      connect: {},
      api: "Amazon-Seller",
      obj: {
        comparison: "India",
      },
      sHow: false,
      showorganizationform: false,
      top_level_org_name: "",
      Typeofbusiness: null,
      targeted_monthly_sale: null,
      targeted_ad_cost: null,
      tax_details: "",
      operating_country: { label: "India", value: "India" },
      preferred_timezone: 'India Standard Time (GMT+5:30)',
      businessTypes: [
        { label: "Agency", value: "agency" },
        { label: "Brand", value: "brand" },
        { label: "Re-Seller", value: "re-seller" },

      ],
      Countrywithcodes: [
        { label: "+1", value: "USA", flag: 'https://www.countryflags.com/wp-content/uploads/united-states-of-america-flag-png-large.png' },
        { label: "+52", value: "Mexico" },
        { label: "+55", value: "Brazil" },
        { label: "+34", value: "Spain" },
        { label: "+44", value: "United Kingdom" },
        { label: "+33", value: "France" },
        { label: "+32", value: "Belgium" },
        { label: "+31", value: "Netherlands" },
        { label: "+49", value: "Germany" },
        { label: "+39", value: "Italy" },
        { label: "+46", value: "Sweden" },
        { label: "+27", value: "South Africa" },
        { label: "+48", value: "Poland" },
        { label: "+20", value: "Egypt" },
        { label: "+90", value: "Turkey" },
        { label: "+966", value: "Saudi Arabia" },
        { label: "+971", value: "UAE" },
        { label: "+91", value: "India" },
        { label: "+65", value: "Singapore" },
        { label: "+61", value: "Australia" },
        { label: "+81", value: "Japan" }],
      Countries: [
        { label: "Canada", value: "Canada" },
        { label: "USA", value: "USA" },
        { label: "Mexico", value: "Mexico" },
        { label: "Brazil", value: "Brazil" },
        { label: "Spain", value: "Spain" },
        { label: "United Kingdom", value: "United Kingdom" },
        { label: "France", value: "France" },
        { label: "Belgium", value: "Belgium" },
        { label: "Netherlands", value: "Netherlands" },
        { label: "Germany", value: "Germany" },
        { label: "Italy", value: "Italy" },
        { label: "Sweden", value: "Sweden" },
        { label: "South Africa", value: "South Africa" },
        { label: "Poland", value: "Poland" },
        { label: "Egypt", value: "Egypt" },
        { label: "Turkey", value: "Turkey" },
        { label: "Saudi Arabia", value: "Saudi Arabia" },
        { label: "UAE", value: "UAE" },
        { label: "India", value: "India" },
        { label: "Singapore", value: "Singapore" },
        { label: "Australia", value: "Australia" },
        { label: "Japan", value: "Japan" },

      ],
      countryTimezones:
      {
        "Canada": [
          "Eastern Standard Time  (GMT-5)",
          "Newfoundland Standard Time (GMT-3:30)",
          "Atlantic Standard Time (GMT-4)",
          "Central Standard Time (GMT-6)",
          "Central Standard Time (GMT-6)",
          "Mountain Standard Time (GMT-7)",
          "Pacific Standard Time (GMT-8)"
        ],
        "USA": [
          "Eastern Standard Time (GMT-5)",
          "Central Standard Time (GMT-6)",
          "Mountain Standard Time (GMT-7)",
          "Mountain Standard Time (GMT-7)",
          "Pacific Standard Time (GMT-8)",
          "Alaska Standard Time (GMT-9)",
          "Hawaii-Aleutian Standard Time (GMT-10)"
        ],
        "Mexico": [
          "Central Standard Time (GMT-6)",
          "Mexican Pacific Standard Time (GMT-7)",
          "Pacific Standard Time (GMT-8)"
        ],
        "Brazil": [
          "Brasilia Standard Time (GMT-3)",
          "Fernando de Noronha Standard Time (GMT-2)",
          "Brasilia Standard Time (GMT-3)",
          "Amazon Standard Time (GMT-4)",
          "Acre Standard Time (GMT-5)"
        ],
        "Spain": [
          "Central European Standard Time (GMT+1)"
        ],
        "United Kingdom": [
          "Greenwich Mean Time (GMT)"
        ],
        "France": [
          "Central European Standard Time (GMT+1)"
        ],
        "Belgium": [
          "Central European Standard Time (GMT+1)"
        ],
        "Netherlands": [
          "Central European Standard Time (GMT+1)"
        ],
        "Germany": [
          "Central European Standard Time (GMT+1)"
        ],
        "Italy": [
          "Central European Standard Time (GMT+1)"
        ],
        "Sweden": [
          "Central European Standard Time (GMT+1)"
        ],
        "South Africa": [
          "South Africa Standard Time (GMT+2)"
        ],
        "Poland": [
          "Central European Standard Time (GMT+1)"
        ],
        "Egypt": [
          "Eastern European Standard Time (GMT+2)"
        ],
        "Turkey": [
          "Time zone in Turkiye (GMT+3)"
        ],
        "Saudi Arabia": [
          "Arabian Standard Time (GMT+3)"
        ],
        "UAE": [
          "Gulf Standard Time (GMT+4)"
        ],
        "India": [
          "India Standard Time (GMT+5:30)"
        ],
        "Singapore": [
          "Singapore Standard Time (GMT+8)"
        ],
        "Australia": [
          "Australian Eastern Daylight Time (GMT+11)",
          "Norfolk Island Daylight Time (GMT+12)",
          "Australian Central Daylight Time (GMT+10:30)",
          "Australian Western Standard Time (GMT+8)",
          "Christmas Island Time (GMT+7)"
        ],
        "Japan": [
          "Japan Standard Time (GMT+9)"
        ]
      },
      showregion: false,
      showsellerRegion: false,
      selectedImage: null,
      selectedSeller: null,
      selectedRegion: null,
      regionImages: {
        "Select Region": require("@/assets/map.webp"),
        "us-east-1": require("@/assets/map1.jpg"),
        "eu-west-1": require("@/assets/map2.jpg"),
        "eu-west-2": require("@/assets/map3.jpg"),
        // Add more regions and their corresponding image paths as needed
      },
      selectedImages: null,
      selectedBox: "Amazon-Advertising",
      selectedBox1: "Amazon-Seller",
      showmerchants: false,
      showappcontainer: false,
      showprofiles: false,
      auth_code: "data",
      org_id: "",
      // top_level_orgid: "",
      selectAll: true,
      tabulardata: undefined,
      selectedRows: [],
      showsuccessmsg: false,
      showproductsdata: false,
      selectedItems: [],
      showNorthAmerica: false,
      showRegionGpedProfiles: false,
      sellerType: [],
      sellers: {},
      selectedColumnValue: [],
      selectcountrycode: '',
      requiredRule: [(v) => !!v || 'Business Name is required'],
      businessNameError: false,
      operatingcountry: false,
      typeofbusiness: false,
      timezones: [],
      showphnoverification: false,
      selectedCountry: '',
      phoneNumber: '',
      otp: '',
      isSendButtonDisabled: false,
      verificationCode: '',
      loading: false,
      otpErrormessage: '',
      orgerrorMessage: '',
      verifyErrormsg: '',
      selectCheckbox: true,
      alertmessage: '',
      otpSent: false,
      phoneNumberError: '',
      phoneNumber: '',
      otp: '',
      isOtpEntered: false,
      isResendButtonDisabled: false,
      resendTimer: 0,
      OTPverifymessage: '',
      top_level_org_nameError: '',
      bussinesstypeError: '',
      operating_country_error: '',
      otpsuccessmsg: '',
    };
  },
  // watch: {
  //   selectAll(newVal) {
  //     this.tabulardata.forEach((item) => (item.isSelected = newVal));
  //   },
  // },
  async created() {
    this.$q.loading.show({
      message: "Authenticating please wait..",
    });
    // console.log("auth1")
    if (this.$cookies.isKey("login_authentication")) {
      // console.log("auth login", this.$cookies.get("login_authentication"))
      let encryptedText = this.$cookies.get("login_authentication");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      this.$store.dispatch("setPathName", "/home");
      this.$q.loading.hide();
      this.isAuthenticated = true;
    } else if (this.$cookies.isKey("login_authentication1")) {
      // console.log("auth2")
      let encryptedText = this.$cookies.get("login_authentication1");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      this.$store.dispatch("setPathName", "/home");
      this.$q.loading.hide();
      this.isAuthenticated = true;
    } else if (this.$cookies.isKey("login_authentication2")) {
      // console.log("auth3")
      let encryptedText = this.$cookies.get("login_authentication2");
      const decryptedText = this.$CryptoJS.AES.decrypt(
        encryptedText,
        process.env.VUE_APP_ENCRYPTION_SECRET_KEY
      ).toString(this.CryptoJS.enc.Utf8);
      this.$store.dispatch("setPathName", "/home");
      this.$q.loading.hide();
      this.isAuthenticated = true;
    }
  },
  async mounted() {



    await this.waitForLayoutInitialized();
    await this.signIn();


  },
  computed: {

    isPhoneNumberValid() {
      return this.phoneNumber.length !== 10;
    },
    filteredBusinessName() {
      // Remove leading and trailing spaces
      const trimmedInput = this.top_level_org_name.trim();

      // Split the input into words
      const words = trimmedInput.split(/\s+/);

      // Build the result by adding words until the total length is 15 characters or less
      let result = '';
      for (const word of words) {
        if (result.length + word.length <= 15) {
          result += `${word} `;
        } else {
          // Stop adding words if the limit is reached
          break;
        }
      }

      // Remove the trailing space, if any
      return result.trim();
    },

    seller_api_URL() {
      return this.dynamic_url;
    },
    amazon_api() {
      return this.amazon_url;
    },
    isdisableverify() {
      return this.otp.length !== 6;

    },
    disablenext() {
      return !(
        this.top_level_org_name &&
        this.Typeofbusiness !== null &&
        this.operating_country &&
        this.preferred_timezone
      );

    },

  },
  methods: {
    back() {
      this.showprofiles = true;
      this.showproductsdata = false;
    },


    onSelect(event) {
      // Do something with the selected dial code
      console.log('Selected dial code:', event);
      // Access the corresponding item in your tabledata using the index
      this.selectedCountry = "+" + event.dialCode

    },
    validateNumberInput() {
      // Use this method to validate the input and remove non-numeric characters
      // For example, you can remove non-numeric characters using regex
      this.targeted_monthly_sale = this.targeted_monthly_sale.replace(/[^0-9]/g, '');
      this.targeted_ad_cost = this.targeted_ad_cost.replace(/[^0-9]/g, '');
    },
    async waitForLayoutInitialized() {
      return new Promise((resolve) => {
        const checkLayout = () => {
          if (this.$layoutInitialized.label === true) {
            resolve();
          } else {
            setTimeout(checkLayout, 100); // Adjust the interval as needed
          }
        };
        checkLayout();
      });
    },
    async signIn() {
      this.$q.loading.show({
        message: "Authenticating Signin...",
      });
      console.log('watch1:', this.$layoutInitialized.label)
      console.log("global1", this.$top_level_orgid, "global2", this.$org_id.label, 'global 3', this.$allorgList);
      // check if there is accounts that is connected
      if (
        this.$org_id.label !== null &&
        this.$org_id.label !== undefined &&
        this.$org_id.label !== ""
      ) {
        this.$q.loading.hide();
        console.log('Landing data sync');
        //  redirect to datasync page or homedashboard
        localStorage.setItem("orgid", this.$org_id.label);
        this.connectedSeller = "Connected";
        this.connectedAdvertising = "Connected";
        // this.homeDashboard();

        this.$router.push("/settings");
        // for testing below can be used
        // this.$router.push("/communication/gAAAAABljFAPT2OOh7FAEMmqQ25DI7EjfJl4pzhy_jfpZxjjhRvFBlH45zC6fo37Aea_scU2Qwlq-2jcCcyF-TkQ5S4QgQHWeA==");
      }
      // check if org form has been filled or not
      else if (
        this.$top_level_orgid.label === null ||
        this.$top_level_orgid.label === undefined ||
        this.$top_level_orgid.label === ""
      ) {
        //  show org form 
        this.$q.loading.hide();
        console.log('Landing org form');
        this.showorganizationform = true;

      } else if (this.$userVerified.label === false || this.$userVerified.label === null) {
        this.$q.loading.hide();
        console.log('Landing phone form');
        //  show mobile verification pop up 
        // this.connect_accounts('initial');
        this.top_level_org_name = localStorage.getItem("top_level_org_name");
        this.showphnoverification = true;
      } else {
        // deciding which pop up to show based on connection status
        //  check connection status 
        let stage;
        // localStorage.setItem('sp_api_connection', 'error');
        var connectingData = this.api_url + `/amazon-ad/get_profile_data/${this.$top_level_orgid.label}`;
        stage = 'profile_selection';
        this.$q.loading.show({
          message: "Fetching user connection status",
        });
        // this.showappcontainer = true;
        // this.sHow = true;
        //   this.showLoadingDialog = true;
        this.$http
          .get(connectingData)
          .then((response) => {

            this.$allorgList.list = response.data;
            console.log('allorgList', this.$allorgList.list.length)

            if (this.$allorgList.list.length > 0) {
              console.log('ad');
              const selected = this.filterSelectedItems(this.$allorgList.list, true)
              // this.$q.loading.hide();
              if (selected.length > 0) {
                //  show connection pop up if token generation is not in progress or failed 
                if (localStorage.getItem('sp_api_connection') === 'error' || localStorage.getItem('sp_api_connection') !== 'progress') {
                  //  initialise data for the gped region pop up

                  this.gped_regiondata(selected);
                  stage = 'sp_api_connection';
                }

              } else {
                // initialise data for the table
                this.tabulardata = this.$allorgList.list;
                this.tabulardata.forEach((item) => {
                  item.selected = true;

                });
                stage = 'profile_selection';
              }
            } else {
              if (localStorage.getItem('ad_connection') === 'progress' || localStorage.getItem('ad_connection') === 'true') {
                console.log('Getting profile data')
                localStorage.setItem('ad_connection', '');
                stage = 'profile_selection';
                // var connectingData = this.api_url + `/amazon-ad/get_profile_data/${this.$top_level_orgid.label}`;
                // stage = 'profile_selection';
                // this.$http
                //   .get(connectingData)
                //   .then((response) => {
                //     localStorage.setItem('ad_connection', '');
                //     this.$allorgList.list = response.data;
                //     this.tabulardata = response.data;
                //     this.tabulardata.forEach((item) => {
                //       item.selected = true;

                //     });
                //     stage = 'profile_selection';

                //   })
                //   .catch((error) => {
                //     console.error("Error making GET request", error);
                //   });

              } else {
                stage = 'initial'
              }

            }
            console.log('Landing connection', stage);

            this.connect_accounts(stage);

          })
          .catch((error) => {
            console.error("Error making GET request", error);
          }).finally(() => {
            this.$q.loading.hide();
          });

      }

    },
    filteredItems(items, status) {
      // Use the filter method to get items where connection_status is 'connected'
      return items.filter((item) => item.connection_status === status);
    },
    filterSelectedItems(items, status) {
      // Use the filter method to get items where connection_status is 'connected'
      return items.filter((item) => item.selection_status === status);
    },
    // resendOTP() {
    //   this.isNoValid = true;
    //   console.log(this.selectedCountry)
    //   this.sendOTP()
    //   this.resendTimer = 30;

    //   // Decrease the timer every second
    //   const timerInterval = setInterval(() => {
    //     this.resendTimer--;

    //     // Check if the timer has reached 0
    //     if (this.resendTimer === 0) {
    //       clearInterval(timerInterval); // Stop the timer
    //     }
    //   }, 1000);
    //   // this.sendOTP()

    // },

    sendOTP() {
      console.log(this.selectedCountry)
      this.isSendButtonDisabled = true;
      this.startTimer();
      const phoneNo = [{
        phoneno: this.phoneNumber,
        agency: this.top_level_org_name,
        isd_code: this.selectedCountry
      }];
      var productsURL = this.api_url + `/multiuser/verify_master_phnno/${this.$top_level_orgid.label}`;

      this.$http
        .post(productsURL, phoneNo)
        .then(response => {
          console.log(response.data);

          if (response.data.message === 'success') {
            this.otpsuccessmsg = 'OTP sent successfully!'
            const now = new Date();
            const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
            const istTime = now.toLocaleString('en-US', options);
            this.$mixpanel.track('Phone Number Verification', {
              UserEmail: localStorage.getItem('email'),
              Path: 'User accessed the PhoneNumber verification popup and OTP sent successfully.',
              Action: 'OTP Sent', // Specify the action taken in the popup
              PopupType: 'Verification', // Type of popup (e.g., Verification, Confirmation, etc.)
              VerificationMethod: 'Whatsapp Message', // Method used for verification (e.g., SMS, email, etc.)
              VerificationStatus: 'Success', // Status of verification (e.g., Success, Failure)
              Date: new Date().toDateString(),
              Time: istTime, // Timestamp of verification attempt
              CountryCode: this.selectedCountry, // Country code associated with phone number
            });

          } else {
            this.otpErrormessage = 'Error in sending OTP'
          }



        })
        .catch(error => {

          this.$mixpanel.track('Error in Phone Number Verification', {
            UserId: localStorage.getItem('email'),
            Error: 'The user encountered an issue in sending OTP while attempting to access the PhoneNumber Verification popup.'
          });
          this.$q.notify({
            type: 'negative',
            message: 'OTP didnt send'
          })
        })

    },
    verifyOTP() {
      this.isOtpEntered = true;
      console.log(this.selectedCountry)
      const formData = {
        phone_no: this.phoneNumber,
        verification_status: true,
        isd_code: this.selectedCountry.label,
        otp: this.otp
      };
      console.log('id:', this.$top_level_orgid.label)
      this.$q.loading.show({
        message: "Validating ...",
      });
      this.$http
        .post(this.api_url + `/multiuser/save_master_phnno/${this.$top_level_orgid.label}`, formData)
        .then((response) => {
          // Handle the response if needed
          console.log("Response is saved", response.data);
          if (response.data.message === 'otp_matched') {

            this.$q.notify({
              type: 'positive',
              message: 'OTP verified successfully'
            });
            this.$userVerified.label = true;
            this.showphnoverification = false;
            this.connect_accounts('initial');
            const now = new Date();
            const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
            const istTime = now.toLocaleString('en-US', options);
            this.$mixpanel.track('Phone number verified(Whatsapp)', {
              UserId: localStorage.getItem('email'),
              Path: 'User accessed the PhoneNumber verification popup and OTP verified successfully.',
              Action: 'OTP Verified', // Specify the action taken in the verification process
              VerificationMethod: 'SMS', // Method used for verification (e.g., SMS, email, etc.)
              VerificationStatus: 'Success', // Status of verification (e.g., Success, Failure)
              Date: new Date().toDateString(),
              Time: istTime,
              CountryCode: this.selectedCountry,
            });

          }
          else {
            this.verifyErrormsg = 'Invalid!.Please check once again'
            this.$mixpanel.track('Error in verifying Phone number', {
              UserId: localStorage.getItem('email'),
              Error: 'The user encountered an issue in verifying OTP while attempting to access the PhoneNumber verification popup!.'
            });
            this.$q.loading.hide();
          }

        })
        .catch((error) => {
          this.verifyErrormsg = 'Invalid!.Please check once again'
          console.error("Error saving data:", error);
          // this.showorganizationform = true;
        }).finally(() => {
          this.$q.loading.hide();
        });


    },
    // sendOTP() {
    //   // Your logic for sending OTP
    //   // Disable send button for 30 seconds
    //   this.isSendButtonDisabled = true;
    //   this.startTimer();
    // },
    // verifyOTP() {
    //   // Your logic for verifying OTP
    //   this.isOtpEntered = true;
    //   this.closeDialog();
    // },
    startTimer() {
      this.timerCountdown = 15;
      let countdown = this.timerCountdown;
      const timer = setInterval(() => {
        if (countdown > 0) {
          countdown--;
          this.timerCountdown = countdown;
          console.log(this.timerCountdown)
        } else {
          clearInterval(timer);
          this.isSendButtonDisabled = false;
          this.timerCountdown = 0;
        }
      }, 1000);
    },
    closeDialog() {
      // Your logic to close the dialog
      this.showOtpDialog = false;
    },
    onPhoneNumberInput() {

      if (this.phoneNumber.length === 10) {
        this.isNoValid = true;

      }
      console.log('Phone number changed:', this.phoneNumber);
    },
    onOtpInput() {
      if (this.otp.length === 6) {
        this.isOtpEntered = true;

      }
      else {
        this.isOtpEntered = false;
      }
      console.log('Phone number changed:', this.otp);
    },
    focusNextBox(index, event) {
      const value = event.target.value;
      this.otp.splice(index, 1, value);

      // Move focus to the next input box
      if (index < 6 && value !== '') {
        this.$refs[`otpInput${index + 1}`].focus();
      }


    },
    handlebackspace(index, event) {
      if (event.key === 'Backspace' && !this.otp[index] && index > 1) {
        event.preventDefault();
        this.otp[index] = '';
        this.$refs[`otpInput${index - 1}`].focus();

      }
    },
    next() {

      if (this.top_level_org_name && this.Typeofbusiness !== null && this.operating_country && this.preferred_timezone) {
        // All fields are filled, move to the next step
        this.$q.loading.show({
          message: "Loading ...",
        });
        const formData = {
          top_level_org_name: this.top_level_org_name,
          business_type: this.Typeofbusiness,
          targeted_monthly_sale: this.targeted_monthly_sale,
          targeted_ad_cost: this.targeted_ad_cost,
          operating_country: this.operating_country['value'],
          preferred_timezone: this.preferred_timezone,
        };
        this.$http
          .post(this.api_url + "/multiuser/save_org_form_details", formData)
          .then((response) => {
            // Handle the response if needed
            console.log("Response is saved", response.data);
            this.$top_level_orgid.label = response.data["top_level_orgid"];
            localStorage.setItem(
              "top_level_orgid",
              response.data["top_level_orgid"]
            );
            localStorage.setItem("top_level_org_name", this.top_level_org_name);
            console.log('orgname', this.top_level_org_name)

            // Close the organization form dialog
            this.showorganizationform = false;
            this.$q.loading.hide();
            this.showphnoverification = true;
            const now = new Date();
            const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
            const istTime = now.toLocaleString('en-US', options);
            this.$mixpanel.track('Organizationform Popup', {
              UserEmail: localStorage.getItem('email'),
              Path: 'User accessed the Organization form popup and data saved successfully.',
              Action: 'Engaged with popup', // Add an action to indicate user interaction
              ButtonClicked: 'Next', // If there's a submit button, track which button the user clicked
              Date: new Date().toDateString(),
              Time: istTime,


            });


          })
          .catch((error) => {
            this.$q.loading.hide();
            console.error("Error saving data:", error);
            // this.showorganizationform = true;

            this.$mixpanel.track('Failed Organization Form Popup', {
              UserId: localStorage.getItem('email'),
              Error: 'The user encountered an issue while attempting to access the Organization Form popup.'
            });

          });

        this.$http
          .post(this.api_url + `/multiuser/welcome_email/${this.top_level_org_name}`)
          .then((response) => {

            console.log('Welcome Email Sent Successfully!', this.top_level_org_name, response.data)
          })
          .catch((error) => {
            console.log('Error', error)
          })


      }
      if (this.top_level_org_name === '') {

        this.top_level_org_nameError = 'Please fill the Business Name'
      }
      if (this.Typeofbusiness === null) {
        this.bussinesstypeError = 'Please fill the Business Type'

      }
      if (this.operating_country === null && this.preferred_timezone === null) {
        this.operating_country_error = 'Please fill the Country and Time zone'
      }

    },
    calculateTimeSpentOnPopup() {
      const startTime = new Date(); // Get the start time stored in localStorage
      const endTime = new Date(); // Get the current time
      const timeSpent = (endTime - startTime) / 1000; // Calculate time spent in seconds
      return timeSpent;
    },
    updateTimezones() {
      console.log(" timezones", this.operating_country)
      if (this.operating_country) {
        console.log("here")
        this.timezones = this.countryTimezones[this.operating_country.value] || [];
        this.preferred_timezone = null; // Reset the selected timezone when country changes
      } else {
        this.timezones = [];
        this.preferred_timezone = null;
      }
      console.log(" timezones", this.timezones)
    },

    getSelectedMessage() {
      switch (this.Typeofbusiness) {
        case "re-seller":
          return "You are a seller in Amazon";
        case "agency":
          return "You manage multiple sellers in Amazon";
        case "brand":
          return "You sell brand(s) in Amazon";
        default:
          return "Select your type of business";
      }
    },


    selectAllCheckboxes() {
      // Update the selected state of all checkboxes based on the "Select All" checkbox
      if (this.selectAll === true) {
        this.tabulardata.forEach((item) => {
          item.selected = true;
          if (!this.selectedItems.includes(item)) {
            this.selectedItems.push(item);
          }
        });
      } else {
        this.tabulardata.forEach((item) => {
          item.selected = false;
        });
        this.selectedItems = [];
      }
    },
    handleCheckboxChange(index) {
      this.tabulardata[index].selected = !this.tabulardata[index].selected;

      if (this.tabulardata[index].selected) {

        this.selectedItems.push(this.tabulardata[index]);


      } else {

        this.selectedItems = this.selectedItems.filter((item) => item !== this.tabulardata[index]);

      }
      this.selectAll = this.selectedItems.length === this.tabulardata.length;
    },

    get_country_names(country_list) {
      return country_list.join(', ');
    },
    getCountryLabel(count) {
      return count === 1 ? 'country' : 'countries';
    },
    handleOkayClick() {
      // Handle the "Okay" button click
      this.showCustomAlert = false;
      console.log('Okay button clicked');
      this.showproductsdata = true;
      this.showRegionGpedProfiles = true
      this.showprofiles = false;

      // Close the custom dialog

    },
    authorizeRegion(endpoint, region, seller_id, profile_name) {
      localStorage.setItem(
        "region",
        region
      );
      localStorage.setItem(
        "seller_id",
        seller_id
      );
      console.log("endpoint::", endpoint)
      window.location.href = endpoint;
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options);
      this.$mixpanel.track('Connecting Sellers', {
        path: 'User clicked to the button to connect the sellers',
        UserEmail: localStorage.getItem('email'),
        Region: region,
        SellerName: profile_name,
        Date: new Date().toDateString(),
        Time: istTime,
        Action: 'Page loaded and connecting through Amazon seller central, redirect to uniqin Application'

      })
    },
    selectAllRows() {
      // Toggle the selectAll flag
      this.selectAll = !this.selectAll;
    },
    savedata() {

      this.$q.loading.show({
        message: "Loading ...",
      });

      const selectedItems = this.tabulardata.filter((item) => item.selected);
      const updatedSelectedItems = selectedItems.map((item) => ({
        ...item,
        selection_status: true,
      }));
      console.log("selected items", updatedSelectedItems);
      // save the selected items in db
      var profileURL = this.api_url + "/amazon-ad/update_selection_status/" + this.$top_level_orgid.label;
      this.$http
        .post(profileURL, updatedSelectedItems)
        .then((response) => {
          console.log("Data saving status", response.data);
          this.gped_regiondata(updatedSelectedItems);
          const now = new Date();
          const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
          const istTime = now.toLocaleString('en-US', options)
          this.$mixpanel.track('Profile Data', {
            ButtonName: 'Continue',
            Path: 'User Clicked Continue to save profile Data',
            Date: new Date().toDateString(),
            Time: istTime,
            Status: 'Success'
          })
          // this.$q.loading.hide();
        })
        .catch((error) => {
          console.log("error", error);
          this.$mixpanel.track('Error whils saving Profile Data', {
            ButtonName: 'Continue',
            Path: 'User encountered some issue while saving the data',
            Time: new Date().toDateString(),
            Status: 'Failed'
          })
          this.$q.loading.hide();
        });
      //  call the function to gp the data regionqise and save current status



    },
    gped_regiondata(updatedSelectedItems) {
      this.$q.loading.show({
        message: "Loading previous state...",
      });
      var profileURL = this.api_url + "/amazon-ad/authorise_seller_central/" + this.$top_level_orgid.label;
      this.$http
        .post(profileURL, updatedSelectedItems)
        .then((response) => {
          console.log("profiledata", response.data);
          this.sellers = response.data;

          setTimeout(() => {
            if (localStorage.getItem('sp_api_connection') === 'error') {
              localStorage.setItem('sp_api_connection', '');
              this.showCustomAlert = true;
            } else {
              this.showprofiles = false;
              this.showproductsdata = true;
              this.showRegionGpedProfiles = true

            }


            // Hide the loading message
            this.$q.loading.hide();

            // console.log('sellers', this.sellers)
            // this.showNorthAmerica = sellerTypes;


          }, 2000);
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    selectAllRows() {
      this.tableData.forEach((row) => {
        row.checkbox = this.selectAll;
      });
    },

    selectBox(box) {
      if (this.connectedAdvertising !== "Connected") {
        return; // Do nothing if not connected
      }
      this.selectedBox = box;
    },
    selectBox1(box1) {
      this.selectedBox1 = box1;
    },
    onItemClick(seller) {
      this.selectedSeller = seller;
      console.log("Selected Seller:", this.selectedSeller);
    },
    onclickregion(region) {
      this.selectedRegion = region;
      console.log("Selected Region:", this.selectedRegion);
      this.selectedImages = this.regionImages[region] || null;
    },
    amazon_apis() {
      //  not in use
      // window.location.href = this.amazon_api;

      this.$q.loading.show({
        message: "Loading ...",
      });
      console.log("api");
      setTimeout(() => {
        this.showprofiles = true;
        // this.showappcontainer=false;

        // Hide the loading message
        this.$q.loading.hide();
      }, 2000);
      this.showmerchants = false;
    },
    selectImage(index) {
      this.selectedImage = index;
    },
    async connect_accounts(stage) {
      console.log('ac connect');
      // this.$q.loading.hide();
      this.showLoadingDialog = false;
      this.showappcontainer = true;
      this.sHow = true;
      console.log('stage', stage);
      if (stage === 'initial') {
        console.log('if', stage);
        this.AdConnection = true;
      } else if (stage === 'profile_selection') {
        console.log('elif', stage);
        this.showprofiles = true;
      } else if (stage === 'sp_api_connection') {
        // console.log('elif 2', stage);
        if (localStorage.getItem('sp_api_connection') === 'error') {
          // localStorage.setItem('sp_api_connection', '');
          this.showCustomAlert = true;
        } else {
          this.showproductsdata = true;
          this.showRegionGpedProfiles = true;
        }


      } else {
        this.showLoadingDialog = true;
      }


      this.connectedSeller = "Connected Amazon selling partner";
      this.connectedAdvertising = "Connected Amazon Advertising";

      this.showsuccessmsg = false;
    },
    connection(item) {
      if (item == "Amazon-Advertising") {
        this.$q.loading.show({
          message: "Loading ...",
        });
        localStorage.setItem("orgid", this.$org_id.label);
        console.log("global", this.globalVariable, this.$org_id.label);
        var user_url =
          this.api_url + "/amazon-ad/ad_user_exists/" + this.$org_id.label;
        console.log("url", this.$org_id.label);
        console.log(this.$orgName.label);
        this.$http
          .post(user_url)
          .then((response) => {
            if (response.data.length == 0) {
              this.api = "Amazon-Advertising";
              this.sHow = true;
              var url = this.api_url + "/amazon-ad/get_seller_api_url1";
              this.$http
                .post(url)
                .then((response) => {
                  this.amazon_url = response.data;
                  this.$q.loading.hide();
                })
                .catch((err) => {
                  this.$q.notify({
                    message: err,
                    color: "negative",
                  });
                });
            } else {
              this.connectedAdvertising = "Connected";
              this.homeDashboard();
              this.$q.loading.hide();
            }
          })
          .catch((err) => {
            this.$q.notify({
              message: err,
              color: "negative",
            });
          });
      } else {
        this.$q.loading.show({
          message: "Loading ...",
        });
        localStorage.setItem("orgid", this.$org_id.label);
        var user_url =
          this.api_url + "/products/user_exists/" + this.$org_id.label;
        this.$http.post(user_url).then((response) => {
          if (response.data.length == 0) {
            this.sHow = true;
            var url = this.api_url + "/repricer/get_seller_api_url";
            this.$http
              .post(url)
              .then((response) => {
                this.dynamic_url = response.data;
                this.hide_panel = {
                  "pointer-events": "none",
                  opacity: "0.85",
                };
                this.$q.loading.hide();
              })
              .catch((err) => {
                this.$q.notify({
                  message: err,
                  color: "negative",
                });
              });
          } else {
            this.connectedSeller = "Connected";
            this.$q.loading.hide();
            this.homeDashboard();
          }
        });
      }
    },
    redirectToAmazon() {
      const now = new Date();
      const options = { timeZone: 'Asia/Kolkata', timeStyle: 'short' };
      const istTime = now.toLocaleString('en-US', options)
      this.$mixpanel.track('Connecting Advertisement', {
        UserId: localStorage.getItem('email'),
        Path: 'User accessed the Connecting Advertisement popup and user connected Amazon Advertising.',
        ButtonClicked: 'yes',
        Date: new Date().toDateString(),
        Time: istTime,

      });

      let endpoint = `https://www.amazon.com/ap/oa?client_id=amzn1.application-oa2-client.302c4cf3bec148fe89b9c584997ca73f&scope=advertising::campaign_management&response_type=code&redirect_uri=${this.app_url}/amazonadoptimization/connect/1`
      console.log('endpoint', endpoint)
      window.location.href = endpoint;
      // this.showproductsdata=true;



    },
    redirectToseller() {
      this.showsellerRegion = true;
    },
    redirectToregion() {
      this.showregion = true;
    },

    homeDashboard() {
      if (
        this.connectedAdvertising == "Connected" &&
        this.connectedSeller == "Connected"
      ) {
        this.$router.push("/homedashboard/" + this.$org_encryprt.label);
      }
      this.$q.loading.hide();
    },
  },
};
</script>